export const padsData = [
  // Ordered like the pads in real mpc 2000 xl
  {
    name: 'Pad 13',
    url: require('../media/sounds/808kit/OpenHH808.wav'),
    key: '1',
    isTriggered: false,
  },
  {
    name: 'Pad 14',
    url: require('../media/sounds/808kit/Rimshot808.wav'),
    key: '2',
    isTriggered: false,
  },
  {
    name: 'Pad 15',
    url: require('../media/sounds/808kit/Clave808.wav'),
    key: '3',
    isTriggered: false,
  },
  {
    name: 'Pad 16',
    url: require('../media/sounds/808kit/Cowbell808.wav'),
    key: '4',
    isTriggered: false,
  },
  {
    name: 'Pad 9',
    url: require('../media/sounds/808kit/LowConga808.wav'),
    key: 'q',
    isTriggered: false,
  },
  {
    name: 'Pad 10',
    url: require('../media/sounds/808kit/HiConga808.wav'),
    key: 'w',
    isTriggered: false,
  },
  {
    name: 'Pad 11',
    url: require('../media/sounds/808kit/LowTom808.wav'),
    key: 'e',
    isTriggered: false,
  },
  {
    name: 'Pad 12',
    url: require('../media/sounds/808kit/HiTom808.wav'),
    key: 'r',
    isTriggered: false,
  },
  {
    name: 'Pad 5',
    url: require('../media/sounds/808kit/Kick808_2.wav'),
    key: 'a',
    isTriggered: false,
  },
  {
    name: 'Pad 6',
    url: require('../media/sounds/808kit/Snare808_2.wav'),
    key: 's',
    isTriggered: false,
  },
  {
    name: 'Pad 7',
    url: require('../media/sounds/808kit/Shaker808.wav'),
    key: 'd',
    isTriggered: false,
  },
  {
    name: 'Pad 8',
    url: require('../media/sounds/808kit/Crash808.wav'),
    key: 'f',
    isTriggered: false,
  },
  {
    name: 'Pad 1',
    url: require('../media/sounds/808kit/Kick808_1.wav'),
    key: 'y',
    isTriggered: false,
  },
  {
    name: 'Pad 2',
    url: require('../media/sounds/808kit/Snare808_1.wav'),
    key: 'x',
    isTriggered: false,
  },
  {
    name: 'Pad 3',
    url: require('../media/sounds/808kit/ClosedHH808.wav'),
    key: 'c',
    isTriggered: false,
  },
  {
    name: 'Pad 4',
    url: require('../media/sounds/808kit/Clap808.wav'),
    key: 'v',
    isTriggered: false,
  },
]
